<template>
<div class="all">
  <div class="top">
    <img src="@/assets/img/logo@2x.png" alt="" class="web_logo" @click="goNext(0)"/>
    <div class="van">
      <div class="first" style="color: rgba(255, 255, 255, 0.6);" @click="goNext(0)">
        <button class="navigation">首页</button>
      </div>
      <div class="first" @click="goNext(1)">
      <button class="navigation navigation_second">关于我们</button>
        <div class="underline"></div>
      </div>
    </div>
  </div>
  <div class="address">
    <div class="title">关于一点</div>
    <p>“一点”是北京比特次元科技有限公司开发的一款面向年轻人的综合社交平台。该平台基于用户的非隐私交互数据，运用智能二阶信息数据系统和“一人多面”的算法机制，在最大限度保护用户隐私的同时，帮助用户发现更多且更符合个人兴趣的内容，实现更精准的社交匹配。</p>
    <br/>
    <p>平台融合了动态广场、马上聊、DUIDUI聊、合拍趣友、语音泡泡、心情贴贴等多种互动玩法，帮助用户快速结识兴趣相投的伙伴，降低社交门槛，提升交友体验的趣味性与有效性。
</p>
    <br/>
    <p>“一点”注重营造真诚、轻松的社区氛围，依托智能技术对内容进行动态识别与引导，保障交流环境自然友好。同时，平台建立用户反馈快速响应机制，对社区内可能出现的不良信息或行为进行及时处置，确保用户互动的安全性与舒适度。</p>
    <br/>
    <p>“一点”的核心理念在于以真实数据为基础，推动社区、社群与社交的一体化发展。将人与人的链接维度由传统的“人到人”好友拓展模式，深化至信息单元维度，忠实地还原社会生活本身，在信息数据的基础上重构关系链，并致力于解决传统算法机制下用户在社会化过程中面临的焦虑孤独、信息茧房、信息过载、关系链固化或侵蚀等问题，打造一款真正“有温度”且“懂你”的产品。</p>
    <div class="title_map">联系我们</div>
    <div class="map">
      <img src="@/assets/img/map_web@2x.png" alt="" class="map_pic">
      <div class="map_text">
        <div class="text_item">
          <img src="@/assets/img/icon_name_white@2x.png" alt="" class="icon">
          <div class="text">
            <div class="text_title">公司名称</div>
            <div>北京比特次元科技有限公司</div>
          </div>
        </div>
        <div class="text_item">
          <img src="@/assets/img/icon_address_white@2x.png" alt="" class="icon">
          <div class="text">
            <div class="text_title">地址</div>
            <div style="line-height: 2vw;">北京市朝阳区</div>
            <div>西大望路1号温特莱中心B座601室</div>
          </div>
        </div>
        <div class="text_item">
          <img src="@/assets/img/icon_mailbox_white@2x.png" alt="" class="icon">
          <div class="text">
            <div class="text_title">邮箱</div>
            <div>yidian@yidian.net.cn</div>
          </div>
        </div>
        <div class="text_item" style="margin: 0;">
          <img src="@/assets/img/icon_receive_white@2x.png" alt="" class="icon">
          <div class="text">
            <div class="text_title">公关专访接待</div>
            <div>company@yidian.net.cn</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page_bottom">
      copyright © 2020-2021 一点APP All Rights Reserved.京公网安备11010502043号
      <a href="http://beian.miit.gov.cn/" class="page_bottom_a">京ICP备2020047090号-2</a>
    </div>
</div>
</template>
<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
// const van = [{ name: '首页' }, { name: '关于我们' }]
const goNext = (index) => {
  if (index === 0) {
    router.push({
      path: '/'
    })
  }
  if (index === 1) {
    router.push({
      path: '/address'
    })
  }
}
</script>
<style>
.all{
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.web_logo {
  width: 140px;
  height: 44px;
  position: absolute;
  top: 93px;
  left: 360px;
}
.van {
  position: absolute;
  width: 182px;
  height: 34px;
  top: 93px;
  right: 360px;
  display: flex;
  justify-content: space-between;
}
.first {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  text-align: center;
  color: rgba(255, 255, 255, 0.89);
}
.navigation{
  border: none;
  background: #000;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
}
.navigation_second{
  color: rgba(255, 255, 255, 0.89);
}
.underline {
  width: 24px;
  height: 4px;
  background: rgba(255, 255, 255, 0.89);
  border-radius: 20px;
}
.address{
  width: 1200px;
  height: 1008px;
  margin-top: 211px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title{
  font-weight: 700;
  font-size: 36px;
  line-height: 36px;
  color: rgba(255, 255, 255, 0.89);
  margin-bottom: 64px;
}
p{
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 0.014em;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
}
.title_map{
  font-weight: 700;
  font-size: 36px;
  line-height: 36px;
  color: rgba(255, 255, 255, 0.89);
  margin: 64px 0;
}
.map{
  width: 1100px;
  height: 520px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.map_pic{
  width: 520px;
  height: 520px;
}
.map_text{
  width: 394px;
  height: 372px;
}
.text_item{
  width: 100%;
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.6);
  display: flex;
  margin-bottom: 32px;
}
.text_title{
  margin-bottom: 12px;
}
.icon{
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
.page_bottom {
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 80px;
  margin-bottom: 14px;
}
.page_bottom_a{
  text-decoration: none;
  color: rgba(255, 255, 255, 0.6);
}
</style>
